import { Validators } from '@angular/forms';
import { FieldsOptions } from '@sim/form';

import { SourceArchivial } from '../source-arc';

// tslint:disable-next-line:no-empty-interface
export interface SourceArc {
  docArc: string;
  ordine: number;
}

export interface SourceArcCard {
  ordine: number;
  docArc: SourceArchivial;
}

export const SourceArcMeta: FieldsOptions<SourceArc> = {
  docArc: { validators: Validators.required },
  ordine: { validators: Validators.required }
};
